import { IMeta, IPagination, ISort } from "@delanobgt/admin-core/util/types";
import { produce } from "immer";
import { Reducer } from "redux";
import {
  EProductRequestSortField,
  IProductRequest,
  PProductRequestFilter,
} from "src/core/productRequest/entities";
import { ActionType, createAction, getType } from "typesafe-actions";

/*
 * state
 */
export interface IProductRequestState {
  productRequests: IProductRequest[];
  loading: boolean;
  error: any;
  meta: IMeta;
}

const initialState: IProductRequestState = {
  productRequests: [],
  loading: false,
  error: null,
  meta: {
    limit: 10,
    offset: 0,
    total: 0,
  },
};

/*
 * action types
 */
const FETCH_REQUESTED = "product-request/FETCH_REQUESTED";
const FETCH_SUCCEEDED = "product-request/FETCH_SUCCEEDED";
const FETCH_FAILED = "product-request/FETCH_FAILED";
const POLLING_START_REQUESTED = "product-request/POLLING_START_REQUESTED";
const POLLING_STOP_REQUESTED = "product-request/POLLING_STOP_REQUESTED";

/*
 * action creators
 */
export const actions = {
  fetchRequested: createAction(FETCH_REQUESTED)(),

  fetchSucceeded: createAction(FETCH_SUCCEEDED)<{
    data: IProductRequest[];
    meta: IMeta;
  }>(),

  fetchFailed: createAction(FETCH_FAILED)<any>(),

  pollingStartRequested: createAction(POLLING_START_REQUESTED)<{
    filter: PProductRequestFilter;
    pagination: IPagination;
    sorts: ISort<EProductRequestSortField>[];
    refreshDelay: number;
  }>(),

  pollingStopRequested: createAction(POLLING_STOP_REQUESTED)(),
};
export type TActions = ActionType<typeof actions>;

const reducer: Reducer<IProductRequestState, TActions> = (
  state = initialState,
  action
) => {
  return produce<IProductRequestState>(state, (draft) => {
    switch (action.type) {
      case getType(actions.fetchRequested): {
        draft.loading = true;
        draft.error = null;
        break;
      }
      case getType(actions.fetchSucceeded): {
        const {
          payload: { data, meta },
        } = action;
        draft.productRequests = data;
        draft.loading = false;
        draft.error = null;
        draft.meta = meta;
        break;
      }
      case getType(actions.fetchFailed): {
        const { payload } = action;
        draft.loading = false;
        draft.error = payload;
        break;
      }
    }
  });
};

export default reducer;
